export default __webpack_public_path__ + "static/media/aufsatz.48bfe4ec.png";